import React, { useEffect, useState } from 'react';

const WelcomeModal = () => {
  const [isModalVisible, setIsModalVisible] = useState(false);

  useEffect(() => {
    const lastShownTime = localStorage.getItem('welcomeModalLastShown');
    const currentTime = new Date().getTime();
    const oneHour = 60 * 60 * 1000; // One hour in milliseconds
  
    if (!lastShownTime || currentTime - lastShownTime > oneHour) {
      setIsModalVisible(true);
      localStorage.setItem('welcomeModalLastShown', currentTime);
    }
  }, []);
  

  const closeModal = () => {
    setIsModalVisible(false);
  };
  

  if (!isModalVisible) return null;

  return (
    <div
      className="fixed top-0 left-0 w-full h-full bg-black bg-opacity-80 flex items-center justify-center z-50"
      onClick={closeModal}
    >
      <div
        className="bg-black p-6 rounded-lg text-[#00f6ff] relative max-w-lg"
        onClick={(e) => e.stopPropagation()}
      >
        <button
          onClick={closeModal}
          className="absolute top-2 right-2 text-[#00f6ff] text-xl"
        >
          &times;
        </button>
        <center><svg className="logo" width="75" height="76" viewBox="0 0 75 76" fill="none" xmlns="http://www.w3.org/2000/svg"><g clip-path="url(#clip0_4_886)"><path d="M18.75 0.75H0V19.5H18.75V0.75Z" fill="#00f6ff"></path><path d="M18.75 57H0V75.75H18.75V57Z" fill="#00f6ff"></path><path d="M75 0.75H56.25V19.5H75V0.75Z" fill="#00f6ff"></path><path d="M75 57H56.25V75.75H75V57Z" fill="#00f6ff"></path><path d="M56.25 19.5H18.75V57H56.25V19.5Z" fill="#00f6ff"></path></g><defs><clipPath id="clip0_4_886"><rect width="75" height="75" fill="white" transform="translate(0 0.75)"></rect></clipPath></defs></svg></center>
        <h2 className="text-2xl font-bold mt-4 mb-4">COPE SALADA - Random Generations </h2>
        <h4 className="font-bold mb-4">Generative / Edition of 250 / Minted: 09-10-2024 </h4>
        <p className="mb-2">This website has no affiliation with <a href="https://xcopy.art/" className="text-[#632af8] font-bold hover:text-[#00f6ff]">XCOPY</a>. It contains 1000 randomly generated variations of the original generative artwork for enjooyers. You can check out the minted editions on <a href="https://highlight.xyz/mint/shape:0xab3A867A6b14cc2f3286B9F03698656F8A892e9E" className="text-[#632af8] font-bold  hover:text-[#00f6ff]">Highlight</a></p>
        <p className="mb-2">All XCOPY artwork is under creative commons zero (CC0) license and is free to use.</p>
        <p className="mb-2"><a href="https://xcopy.art/creative-commons" className="text-[#632af8] font-bold  hover:text-[#00f6ff]">NO RIGHTS RESERVED</a></p>
        <button
          onClick={closeModal}
          className="w-full p-2 border border-[#632af8] rounded bg-black text-[#632af8] mt-4 hover:bg-[#632af8] hover:text-[#000000]"
        >
          Close
        </button>
      </div>
    </div>
  );
};

export default WelcomeModal;